import { applyBodyClass, readPreference, usePreference } from './usePreferences';

// Density mode — drives --row-h + --pad-x in src/index.css via the
// body classes `density-{compact|default|comfy}`. Consumed by table
// rows, sub-bar height, form inputs in Phase 2/3; dormant until then.

const STORAGE_KEY = 'toleranz.density';
const VALID = new Set(['compact', 'default', 'comfy']);
const PREFIX = 'density-';

// FOUC prevention — same trick as useTheme. Apply at module load
// before React mounts so layout sizing settles immediately.
if (typeof document !== 'undefined') {
  const initial = readPreference(STORAGE_KEY, VALID, 'default');
  applyBodyClass(PREFIX, VALID, initial);
}

export function useDensity() {
  return usePreference(STORAGE_KEY, VALID, 'default', PREFIX);
}
